import React from 'react';
import { put, select } from 'redux-saga/effects';
import Notification from '@/components/common/notification';
import List from '@/components/common/list';
import Alert from '@/components/common/alert';
import { ACCESS_TOKEN_EXPIRED_MESSAGE, HTTP_CODE } from '@/common/constant';
import { REFRESH_TOKEN } from '../types/authenticate';

/**
 * Handle response was failed from request
 * @param {*} param0
 * @returns
 */
function* onFailRequest({ ...args }) {
  const {
    // payload,
    err = null,
    error = null,
    onCallback = null,
    isAllowShowError = true,
  } = args;
  const { authenticate } = yield select();
  const { responseError = null } = err || error;
  if (!responseError) return;

  const { message, data: msgData } = responseError.data;
  let notificationMsg = message;
  if (responseError.status === HTTP_CODE[401]) {
    notificationMsg = ACCESS_TOKEN_EXPIRED_MESSAGE;
    if (!authenticate.isRefreshToken) {
      yield put({
        type: REFRESH_TOKEN,
      });
    }

    // yield put({
    //   type: RECALL_ACTIONS_FAIL,
    //   action: payload,
    // });
  }
  let msgDescription = null;
  if (responseError.status === HTTP_CODE[422] && msgData) {
    const messageEls = Object.values(msgData).map((el) => (el.length ? el[0] : null));
    msgDescription = (
      <Alert
        message={<List size="small" bordered={false} dataSource={messageEls} />}
        type="error"
        className="notification-request-error"
      />
    );
  }

  if (onCallback) {
    yield onCallback();
  }

  if (isAllowShowError) {
    Notification({
      type: 'error',
      message: notificationMsg,
      description: msgDescription,
    });
  }
}

/**
 * Handle response succeed from request
 * @param {*} args
 */
function* onSuccessRequest(args) {
  const {
    // payload,
    response = null,
    onCallback = null,
    isAllowShowMsg = true,
  } = args;

  const { message } = response;

  if (onCallback) {
    yield onCallback();
  }

  if (isAllowShowMsg) {
    Notification({ type: 'success', message });
  }
}

/**
 * Custom transform request upload file
 */
const multiPartUpload = {
  transformRequest: [
    (data, headers) => {
      const formData = new FormData();
      Object.keys(data).forEach((val) => {
        formData.append(val, data[val]);
      });
      headers['Content-Type'] = 'multipart/form-data';
      return formData;
    },
  ],
};

export { onFailRequest, onSuccessRequest, multiPartUpload };
